export default (player) => {
  // must be youtube and player must have container
  if (player?.config?.provider !== "youtube" || !player?.config.autoplay) {
    return;
  }

  player.on("playing", () => {
    player.muted = false;
  });
};
